import { useState } from 'react';

import { Button, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useUserAccount } from '~/src/hooks/useUserAccount';

import { Wrapper } from './components/Wrapper';

export const ResendVerification = () => {
  const { resendEmailVerification } = useUserAccount();
  const navigate = useNavigate();
  const { t } = useTranslation('', { keyPrefix: 'emailVerification' });

  const [showErrorMsg, setShowErrorMsg] = useState<boolean>(false);

  const handleResendEmailVerification = () =>
    resendEmailVerification(undefined, {
      onError: () => {
        setShowErrorMsg(true);
      },
      onSuccess: () => {
        navigate('/resend_verification/success');
      },
    });

  return (
    <Wrapper>
      <Stack gap={3}>
        <Typography variant="h2">{t('resendVerification.title')}</Typography>
        <Typography>{t('resendVerification.body')}</Typography>
        {showErrorMsg && (
          <Typography sx={{ color: 'error.main' }}>{t('resendVerification.error')}</Typography>
        )}
      </Stack>

      <Button onClick={handleResendEmailVerification} sx={{ fontSize: '0.875rem', mt: 3 }}>
        {t('resendVerification.sendEmail')}
      </Button>
    </Wrapper>
  );
};
